// extracted by mini-css-extract-plugin
export default {"titleContainer":"LocationList_titleContainer__J7L0M"};